<template>
    <el-radio-group :model-value="value" :disabled="!enabled" @update:modelValue="clicked">
        <el-radio v-for="option in options" :key="option.value" :label="option.value">{{ option.label }}</el-radio>
    </el-radio-group>
</template>

<script>
    import { ElRadio, ElRadioGroup } from 'element-plus';

    export default {
        name: 'CicRadioGroup',
        components: {
            'el-radio': ElRadio,
            'el-radio-group': ElRadioGroup,
        },
        props: {
            value: {
                type: [Number, String],
                default: null,
            },

            options: {
                type: Array,
                required: true,
            },

            enabled: {
                type: Boolean,
                default: true,
            },
        },
        emits: ['change', 'input'],
        methods: {
            clicked(value) {
                if (this.enabled) {
                    this.$emit('change', value);
                    this.$emit('input', value);
                }
            },
        },
    };
</script>
